import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgContains = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M17 12.5H7C7 12.5 4 12.5 4 10C4 7.5 7 7.5 7 7.5H17",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgContains;
